import PropTypes from "prop-types";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

const AreaCardRevenue = ({ colors, percentFillValue, cardInfo }) => {
  const filledValue = (percentFillValue / 100) * 360; // 360 degress for a full circle
  const remainedValue = 360 - filledValue;

  // const data = [
  //   { name: "Remained", value: remainedValue },
  //   { name: "Achieved Sales", value: filledValue },
  // ];

  // const renderTooltipContent = (value) => {
  //   return `${(value / 360) * 100} %`;
  // };

  return (
    <div className="area-card">
      <div className="area-card-info">
        <h5 className="info-title">{cardInfo.title}</h5>
        <div className="info-texts">
          <p className="info-text">{cardInfo.text1}</p>
          <p className="info-text">{cardInfo.text2}</p>
          <p className="info-text">{cardInfo.text3}</p>
        </div>
      </div>
      {/* <div className="area-card-chart">
        <PieChart width={100} height={100}>
          <Pie
            data={data}
            cx={50}
            cy={45}
            innerRadius={20}
            fill="#e4e8ef"
            paddingAngle={0}
            dataKey="value"
            startAngle={-270}
            endAngle={150}
            stroke="none"
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
              />
            ))}
          </Pie>
          <Tooltip formatter={renderTooltipContent} />
        </PieChart>
      </div> */}
    </div>
  );
};

export default AreaCardRevenue;

AreaCardRevenue.propTypes = {
  colors: PropTypes.array.isRequired,
  percentFillValue: PropTypes.number.isRequired,
  cardInfo: PropTypes.object.isRequired,
};
